import React from "react";
import "./auth.css";
import axiosMain from "../http/axiosMain";
import { Link, useNavigate } from "react-router-dom";
import loginimg from "../Assets/Img/loginsideimg.png";
import mobile from "../Assets/Img/mail-signup.png";
import googlesignup from "../Assets/Img/google-signup.png";
import mail from "../Assets/Img/mobile-signup.png";
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId =
  "316679652217-44dun9ch1kjuhpmqpdda6ha5t1s3shsn.apps.googleusercontent.com";

function SignUpWith() {
  const navigate = useNavigate();
  const role = localStorage.getItem("userType");

  const handleGoogleSuccess = async () => {
    try {
      // const token = credentialResponse.credential; // Get Google JWT token

      const response = await axiosMain.get("api/auth/google", {
        params: {
          redirect: window.origin,
          role: "brand",
        },
      });

      if (response.data.status) {
        console.log("Authentication Successful:", response.data);
        localStorage.setItem("authToken", true);

        // Store user data
        localStorage.setItem("user", JSON.stringify(response.data.user));
        console.log("google login", response.data);
        window.location.href = response.data.data;

        // Redirect to Brand Home Page
        // navigate("/brand-home");
      } else {
        console.error("Authentication Failed:", response.data.message);
      }
    } catch (error) {
      console.error(
        "Google Login Error:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="container-signup-with-links p-0 mt-5 mb-5">
        <div className="card">
          <div className="row no-gutters">
            <div className="col-12 col-md-6 col-sm-12 left">
              <img src={loginimg} alt="login-side-img" className="img" />
            </div>
            <div className="col-12 col-md-6 col-sm-12 right">
              <div className="heading">
                <div className="title" style={{ paddingTop: "70px" }}>
                  Welcome to InSocial Orbit
                </div>
                {role === "brand" ? (
                  <div style={{ paddingBottom: "60px", textAlign: "center" }}>
                    {/* <p style={{ color: '#6b8e76' }}>
                        You're signing up as a Brand.
                      </p> */}
                    <p
                      style={{
                        color: "#6b8e76",
                        fontSize: "16px",
                        fontWeight: "inherit",
                      }}
                    >
                      Connect with top influencers and run successful campaigns.
                    </p>
                  </div>
                ) : (
                  <div style={{ paddingBottom: "60px", textAlign: "center" }}>
                    {/* <p style={{ color: '#6b8e76' }}>
                        You're signing up as an Influencer.
                      </p> */}
                    <p
                      style={{
                        color: "#6b8e76",
                        fontSize: "16px",
                        fontWeight: "inherit",
                      }}
                    >
                      Collaborate with brands and monetize your influence.
                    </p>
                  </div>
                )}
              </div>

              <div className="buttons">
                <button
                  type="button"
                  className="btn btn-lg mb-2 d-flex align-items-center btn-social"
                  onClick={handleGoogleSuccess}
                >
                  <img
                    src={googlesignup}
                    alt="Phone Icon"
                    className="icon mr-2"
                    style={{
                      width: "17px",
                      height: "25px",
                      marginRight: "16px",
                    }}
                  />
                  Continue with Google
                </button>
                <button
                  type="button"
                  className="btn btn-lg mb-2 d-flex align-items-center btn-social"
                  onClick={() => navigate("/signup-with-phone")}
                >
                  <img
                    src={mail}
                    alt="Phone Icon"
                    className="icon mr-2"
                    style={{
                      width: "17px",
                      height: "25px",
                      marginRight: "16px",
                    }}
                  />
                  Continue with Phone Number
                </button>
                <button
                  type="button"
                  className="btn btn-lg d-flex align-items-center btn-social"
                  onClick={() => navigate("/signup-with-email")}
                >
                  <img
                    src={mobile}
                    alt="Email Icon"
                    className="icon mr-2"
                    style={{
                      width: "25px",
                      height: "20px",
                      marginRight: "10px",
                    }}
                  />
                  Continue with Email
                </button>
              </div>
              {/* this changes do for navigate login page */}
              <div className="col-12 col-md-12 footer  footer-custom">
                <div className="sign-link mt-auto mb-1 ">
                  If you have an account? &nbsp;
                  {/* Add link to navigate back to the signup page */}
                  <Link to="/phone-email" className="btn-link">
                    Login &nbsp;
                  </Link>
                  here
                </div>
                <div className="signup-with">
                  By continuing you agree to our terms and conditions
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}

export default SignUpWith;
